module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-2.5ba229f5.jpg";